import { render, staticRenderFns } from "./ListeningAndWritingActivitiesDialog.vue?vue&type=template&id=54bba1a9&scoped=true&"
import script from "./ListeningAndWritingActivitiesDialog.vue?vue&type=script&lang=ts&"
export * from "./ListeningAndWritingActivitiesDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ListeningAndWritingActivitiesDialog.vue?vue&type=style&index=0&id=54bba1a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54bba1a9",
  null
  
)

export default component.exports